import { useContext } from "react";
import RdtContext from "../context/RdtProvider";

export const useRdt = () =>{
   return useContext (
        RdtContext
   ) 
};
